import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['icon', 'inputs'];

  unselect(event) {
    if (!event.target.checked) {
      this.iconTarget.classList.remove('checked');
    }
  }

  check_toggle() {
    const inputs = this.inputsTarget.querySelectorAll('input');

    if (this.iconTarget.classList.contains('checked')) {
      this.iconTarget.classList.remove('checked');
    } else {
      this.iconTarget.classList.add('checked');
      inputs.forEach((item) => {
        item.checked = true;
      });
    }
  }
}
